<template>
    <div>
        
        <!-- Filter Start -->
        <highlight-filter
            :getFilterOnStart="true"
            :is_customer_page="false"
            @filterChange="changeFilter"
        ></highlight-filter>
        <!-- Filter End -->

        <!-- Stats Start -->
        <div class="row mb-4">
            <div class="col-lg-3 col-md-6">
                <div class="innerBox mt-4">
                    <!-- <div class="row"> -->
                        <div class="col"> <!-- col-8 -->
                        <highlight-oil-maker-stats
                            title="Total QR"
                            :description="tooltip.total_qr"
                            :value="data.stats ? data.stats.total_qr != null ? numberWithCommas(data.stats.total_qr) : 0 : 'Loading...'"
                        ></highlight-oil-maker-stats>
                        </div>
                        <!-- <div class="col-4 stats--icon">
                            <i class="far fa-qrcode fa-5x"></i>
                        </div> -->
                    <!-- </div> -->
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="innerBox mt-4">
                    <!-- <div class="row"> -->
                        <div class="col"> <!-- col-8 -->
                        <highlight-oil-maker-stats
                            title="Total Scan"
                            :description="tooltip.total_scan"
                            :value="data.stats ? data.stats.total_scan != null ? numberWithCommas(data.stats.total_scan) : 0 : 'Loading...'"
                        ></highlight-oil-maker-stats>
                        </div>
                        <!-- <div class="col-4 stats--icon">
                            <i class="far fa-barcode-read fa-4x"></i>
                        </div> -->
                    <!-- </div> -->
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="innerBox mt-4">
                    <!-- <div class="row"> -->
                        <div class="col"> <!-- col-8 -->
                        <highlight-oil-maker-stats
                            title="Total Active"
                            :description="tooltip.total_active"
                            :value="data.stats ? data.stats.active != null ? numberWithCommas(data.stats.active) : 0 : 'Loading...'"
                        ></highlight-oil-maker-stats>
                        </div>
                        <!-- <div class="col-4 stats--icon">
                            <i class="fas fa-check fa-4x"></i>
                        </div> -->
                    <!-- </div> -->
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="innerBox mt-4">
                    <!-- <div class="row"> -->
                        <div class="col"> <!-- col-8 -->
                        <highlight-oil-maker-stats
                            title="Total Deactivate"
                            :description="tooltip.total_deactivate"
                            :value="data.stats ? data.stats.deactivate != null ? numberWithCommas(data.stats.deactivate) : 0 : 'Loading...'"
                        ></highlight-oil-maker-stats>
                        </div>
                        <!-- <div class="col-4 stats--icon">
                            <i class="far fa-times fa-5x"></i>
                        </div> -->
                    <!-- </div> -->
                </div>
            </div>
        </div>
        <!-- Stats End -->

        <!-- Vertical Chart Start -->
        <div class="col-md-13">
                <div class="innerBox chart">
                    <h5 class="elegant--sub-title">
                        QR vs Active
                        <i
                            class="fas fa-info-circle"
                            :id="'scanDeactivateInfo'"
                        ></i>
                        <b-popover target="scanDeactivateInfo" triggers="hover" placement="top">
                          <template #title>QR vs Scan</template>
                            {{tooltip.qr_vs_active}}
                        </b-popover>
                    </h5>
                    <oil-maker-q-r-scan-distribution
                        v-if='data.oilBarScan'
                        :data="data.oilBarScan"
                        :filter="filter"
                    ></oil-maker-q-r-scan-distribution>
                    <div v-else class="text-center mt-5 mb-5">
                        <h2 class="pt-5 pb-5">Loading...</h2>
                    </div>
                </div>
            </div>
        <!-- Vertical Chart End -->

        <!-- Pie Chart Start -->
        <div class="col-md-13 mt-4">
                <div class="innerBox chart">
                    <h5 class="elegant--sub-title">
                        QR Active by Oil Maker
                        <i
                            class="fas fa-info-circle"
                            :id="'oilMarkerInfo'"
                        ></i>
                        <b-popover target="oilMarkerInfo" triggers="hover" placement="top">
                          <template #title>QR Active by Oil Maker</template>
                            {{tooltip.qr_active_by_oil_maker}}
                        </b-popover>
                    </h5>
                    <!-- <h5 class="elegant--sub-title"></h5> -->
                    <oil-maker-q-r-scan-detailed
                        v-if='data.qrScanByOilMaker'
                        :data="data.qrScanByOilMaker"
                    ></oil-maker-q-r-scan-detailed>
                    <div v-else class="text-center mt-5 mb-5">
                        <h2 class="pt-5 pb-5">Loading...</h2>
                    </div>
                </div>
            </div>
        <!-- Pie Chart End -->
        
    </div>
</template>

<script>
    import qs from 'qs'
    import highlightFilter from '@/components/filter/highlightFilter'

    import highlightOilMakerStats from './children/HighlightOilMakerStats'
    import oilMakerQRScanDistribution from './children/OilMakerQRScanDistribution'
    import oilMakerQRScanDetailed from './children/OilMakerQRScanDetailed'

    export default {
        metaInfo : {
            title : 'Highlight - Oil Maker'
        },
        data () {
            return {
                filter : {},
                data : {
                    stats: null,
                    oilBarScan: null,
                    qrScanByOilMaker: null,
                },
                tooltip : this.$store.state.tooltip.highlight.oil_maker
            }
        },
        components : {
            highlightFilter,

            highlightOilMakerStats,
            oilMakerQRScanDistribution,
            oilMakerQRScanDetailed,
        },
        mounted () {
            // this.fetchData();
        },
        methods : {
            changeFilter (filter) {
                for (var i in filter) this.filter[i] = filter[i];
                
                this.fetchData();
            },
            fetchData(){
                //Reset All Data to null
                for (var i in this.data) this.data[i] = null;
                
                //Remove filter from filter
                let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
                delete filterlessFilter.filter;

                //Get Stats
                this.$http.get(`/api/highlight/oilmaker-scan-overview?${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.stats = resp.data.data;
                })
                .catch((err)=>{console.log(err)});

                //Get QR vs Scan
                this.$http.get(`/api/highlight/oilmaker-variant-overview?${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.oilBarScan = resp.data.data;
                })
                .catch((err)=>{console.log(err)});

                //Get QR Scan by Oil Maker
                this.$http.get(`/api/highlight/oilmaker-company-overview?${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.qrScanByOilMaker = resp.data.data;
                })
                .catch((err)=>{console.log(err)});
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }
</style>